// Remove Columns organiser of table
export const removeColumnOrganiser = () => {
  const viewColumns = document.getElementsByClassName('MuiButtonBase-root');
  if (viewColumns && viewColumns.length > 0) {
    for (const view of viewColumns as any) {
      if (
        view.getAttribute('data-testid') &&
        view.getAttribute('data-testid') === 'View Columns-iconButton'
      ) {
        view.remove();
      }
    }
  }
};
